module.exports = __webpack_public_path__ + "acf9419830b736fad04b5cf718795049.pdf";